__turbopack_context__.v({
  "channelCardsWrapper": "flexibleForm-module-scss-module__VtTJUW__channelCardsWrapper",
  "ctaCaption": "flexibleForm-module-scss-module__VtTJUW__ctaCaption",
  "ctaStyles": "flexibleForm-module-scss-module__VtTJUW__ctaStyles",
  "descriptionTextStyles": "flexibleForm-module-scss-module__VtTJUW__descriptionTextStyles",
  "dropdownSelectStyles": "flexibleForm-module-scss-module__VtTJUW__dropdownSelectStyles",
  "duplicationFormError": "flexibleForm-module-scss-module__VtTJUW__duplicationFormError",
  "duplicationFormErrorCentered": "flexibleForm-module-scss-module__VtTJUW__duplicationFormErrorCentered",
  "flexForm": "flexibleForm-module-scss-module__VtTJUW__flexForm",
  "formAlertSpacing": "flexibleForm-module-scss-module__VtTJUW__formAlertSpacing",
  "formSectionHeaderStyles": "flexibleForm-module-scss-module__VtTJUW__formSectionHeaderStyles",
  "formSectionTextBlockStyles": "flexibleForm-module-scss-module__VtTJUW__formSectionTextBlockStyles",
  "fullWidth": "flexibleForm-module-scss-module__VtTJUW__fullWidth",
  "halfWidth": "flexibleForm-module-scss-module__VtTJUW__halfWidth",
  "leftAlignedHeaderStyles": "flexibleForm-module-scss-module__VtTJUW__leftAlignedHeaderStyles",
  "promoCodeEntryAlert": "flexibleForm-module-scss-module__VtTJUW__promoCodeEntryAlert",
  "promoCodeEntryForm": "flexibleForm-module-scss-module__VtTJUW__promoCodeEntryForm",
  "promoCodeEntryInner": "flexibleForm-module-scss-module__VtTJUW__promoCodeEntryInner",
  "promoCodeEntryInput": "flexibleForm-module-scss-module__VtTJUW__promoCodeEntryInput",
  "promoCodeEntryShell": "flexibleForm-module-scss-module__VtTJUW__promoCodeEntryShell",
  "selectContainer": "flexibleForm-module-scss-module__VtTJUW__selectContainer",
  "stateContainer": "flexibleForm-module-scss-module__VtTJUW__stateContainer",
  "stateWrapper": "flexibleForm-module-scss-module__VtTJUW__stateWrapper",
  "subheadlineStyles": "flexibleForm-module-scss-module__VtTJUW__subheadlineStyles",
  "submitButtonWrapperCentered": "flexibleForm-module-scss-module__VtTJUW__submitButtonWrapperCentered",
  "submitButtonWrapperRight": "flexibleForm-module-scss-module__VtTJUW__submitButtonWrapperRight",
  "successErrorWrapper": "flexibleForm-module-scss-module__VtTJUW__successErrorWrapper",
  "successHeadlineStyles": "flexibleForm-module-scss-module__VtTJUW__successHeadlineStyles",
  "toggleFormTextBlockStyles": "flexibleForm-module-scss-module__VtTJUW__toggleFormTextBlockStyles",
  "wrapperRow": "flexibleForm-module-scss-module__VtTJUW__wrapperRow",
  "zipInputStyles": "flexibleForm-module-scss-module__VtTJUW__zipInputStyles",
});
